import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Header from '../../components/HeaderSubPage/HeaderSubPage';
import { FaSmile, FaHandsHelping, FaInfoCircle, FaComments } from 'react-icons/fa'; 
import './SubPage.css';

const MeetVandri = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      className="subpage"
      initial={{ opacity: 0, y: -1}}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="subpage-container">
        <Header />
        <div className="subpage-content">
          <div className="content-section">
            <FaSmile className="content-icon" />
            <h3>{t('aboutVandri.whoAmITitle')}</h3>
            <p>{t('aboutVandri.whoAmIText')}</p>
          </div>
          <div className="content-section">
            <FaHandsHelping className="content-icon" />
            <h3>{t('aboutVandri.howCanIHelpTitle')}</h3>
            <p>{t('aboutVandri.howCanIHelpText')}</p>
          </div>
          <div className="content-section">
            <FaInfoCircle className="content-icon" />
            <h3>{t('aboutVandri.funFactTitle')}</h3>
            <p>{t('aboutVandri.funFactText')}</p>
          </div>
          <div className="content-section">
            <FaComments className="content-icon" />
            <h3>{t('aboutVandri.getStartedTitle')}</h3>
            <p>{t('aboutVandri.getStartedText')}</p>
          </div>
          <div className="content-section">
            <h4>{t('aboutVandri.disclaimerTitle')}</h4>
            <p>{t('aboutVandri.disclaimerText')}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default MeetVandri;
